<template>
    <div>
        <!--<div class="arlt-pishtaz" v-if="cart != null && cart.CartInfo.IsApplyFreeDelivery">
            <div class="close-alrt">
                <div class="close close-alert"><i class="fa fa-close"></i></div>
                <div><span>توجه : سود شما ارسال رایگان با پست پیشتاز</span></div>
            </div>
        </div>-->

        <nav class="navbar direction-ltr header-responsive">

            <div class=" ">
                <a class="navbar-Category" to="/">
                    <img src="/assets/img/logo.png" />
                </a>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },
        computed: {
            //groups: function () {
            //    return this.$store.getters.readGroups;
            //},
            //cart: function () {
            //    return this.$store.getters.readCart;
            //},
            //baseInfo: function () {
            //    return this.$store.getters.readBaseInfo;
            //}
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        methods: {
            removeSearchValue() {
                this.searchValue = '';
            },
            closeNav() {
                $(function () {
                    $('#bodyClick').click();
                });
            }
        }
    }
    $(function () {
        $('body').on('click', '.redirect-subGroup', function () {
            var id = $(this).attr('id');
            var title = $(this).attr('title');
            window.open('/filter?GroupId=' + id + '&GroupName=' + title, '_Blank');

        });
    });
</script>

<style scoped>
    .redirect-subGroup {
        position: absolute;
        z-index: 54;
        top: 18px;
        left: 65px;
        color: #fff;
    }

        .redirect-subGroup:hover {
            cursor: pointer;
        }

    .router-a-i-m img {
        width: 25px;
        height: 30px;
    }

    .bascket-i-m {
        position: relative
    }

        .bascket-i-m .countItem {
            position: absolute;
            right: 5px;
            top: -10px;
        }

    .top-fix-i-m {
        display: flex;
        justify-content: left;
        float: left;
    }

        .top-fix-i-m .router-a-i-m a {
            background-color: transparent;
            font-size: 20px;
            color: #444;
        }

        .top-fix-i-m .router-a-i-m {
            margin-left: 7px;
            margin-right: 7px;
        }

    .navbar-translate .navbar-Category {
        background-color: #fff;
    }

    ul.sub-menu-bg li a {
        background-color: #465157;
    }

    nav.header-responsive ul li ul li ul li .subgroub-li {
        padding-right: 50px;
    }

    .router-a {
        position: relative;
    }

        .router-a:hover .countItem {
            background-color: #5f7c12;
            color: #E5E5E5;
            transition: all .3s;
        }

    .countItem {
        position: absolute;
        right: 5px;
        top: 6px;
        background-color: #E5E5E5;
        padding: 5px;
        border-radius: 20px;
        width: 22px;
        height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #222;
    }

    .hr-res {
        border-top: 2px solid #555;
    }

    nav.header-responsive ul li ul li ul li .category-li {
        padding-right: 50px;
    }

    nav.header-responsive ul > li:hover a.f-a {
        background-color: #1d272a;
    }

    .fix-tag {
        text-align: center;
    }

        .fix-tag .inline-div {
            display: inline-block;
        }

        .fix-tag a:hover i {
            color: #5f7c12;
            transition: all .3s;
        }

        .fix-tag a i {
            font-size: 30px;
            color: #E5E5E5;
            margin: 15px;
            transition: all .3s;
        }

    @media only screen and (min-width:640px) and (max-width: 850px) {
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        nav.header-responsive form {
            position: relative;
            direction: rtl;
            float: right;
            height: 40px;
            width: 100%;
        }

        nav.header-responsive .search-nav ul.info-login {
            float: none;
            text-align: left;
        }

        nav.header-responsive .search-nav ul {
            width: 100%;
        }

            nav.header-responsive .search-nav ul.info-login {
                font-size: 10px !important;
                position: relative;
                top: -87px;
                left: -70px;
            }

            nav.header-responsive .search-nav ul i {
                font-size: 18px;
            }

        .js-search-keyword-link .c-search__result-item {
            font-size: 12px;
        }

        .c-search__results {
            left: 0px;
            max-height: 300px;
            overflow-y: scroll;
            padding: 0
        }

        nav.header-responsive .search-nav ul {
            overflow: auto;
        }

            nav.header-responsive .search-nav ul li {
                float: right;
            }

        nav.header-responsive .search-nav .cearchtags li a {
            display: inline;
        }

        nav.header-responsive .search-nav ul li a {
            font-size: 12px;
            color: #212121 !important;
            background: transparent;
            text-align: right;
            display: inline-block;
        }

        hr {
            display: inline-block;
            width: 100%;
        }

        .c-search__results ul li {
            line-height: 1.4;
        }

        .c-search ul li a {
            text-align: right;
        }
    }
</style>